export interface PreviousJobComparisonStatus {
  hasPreviousJobSettings: boolean;
  isModified: boolean;
  discrepancyLabels: string[];
}

interface PreviousJobComparisonCheck {
  label: string;
  matches: boolean;
}

export const buildPreviousJobComparisonStatus = ({
  hasPreviousJobSettings,
  comparisons,
}: {
  hasPreviousJobSettings: boolean;
  comparisons: PreviousJobComparisonCheck[];
}): PreviousJobComparisonStatus => {
  if (!hasPreviousJobSettings) {
    return {
      hasPreviousJobSettings: false,
      isModified: false,
      discrepancyLabels: [],
    };
  }

  const discrepancyLabels = comparisons.filter(({ matches }) => !matches).map(({ label }) => label);

  return {
    hasPreviousJobSettings: true,
    isModified: discrepancyLabels.length > 0,
    discrepancyLabels,
  };
};
